import axios from 'axios'
import {
    PASSWORD_RESET_REQUEST_REQUEST,
    PASSWORD_RESET_REQUEST_SUCCESS,
    PASSWORD_RESET_REQUEST_FAIL,
    PASSWORD_RESET_REQUEST_RESET,
    PASSWORD_RESET_CONFIRM_REQUEST,
    PASSWORD_RESET_CONFIRM_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAIL,
    PASSWORD_RESET_CONFIRM_RESET,
} from '../constants/passwordResetConstants'

export const requestPasswordReset = (email) => async (dispatch) => {
    try {
        dispatch({ type: PASSWORD_RESET_REQUEST_REQUEST })

        const config = {
            headers: {
                'Content-type': 'application/json',
            },
        }

        const { data } = await axios.post(
            '/api/users/password-reset/request/',
            { email },
            config
        )

        dispatch({
            type: PASSWORD_RESET_REQUEST_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: PASSWORD_RESET_REQUEST_FAIL,
            payload:
                error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
        })
    }
}

export const resetPasswordRequestReset = () => (dispatch) => {
    dispatch({ type: PASSWORD_RESET_REQUEST_RESET })
}

export const confirmPasswordReset = (token, password) => async (dispatch) => {
    try {
        dispatch({ type: PASSWORD_RESET_CONFIRM_REQUEST })

        const config = {
            headers: {
                'Content-type': 'application/json',
            },
        }

        const { data } = await axios.post(
            '/api/users/password-reset/confirm/',
            { token, password },
            config
        )

        dispatch({
            type: PASSWORD_RESET_CONFIRM_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: PASSWORD_RESET_CONFIRM_FAIL,
            payload:
                error.response && error.response.data.detail
                    ? error.response.data.detail
                    : error.message,
        })
    }
}

export const resetPasswordConfirmReset = () => (dispatch) => {
    dispatch({ type: PASSWORD_RESET_CONFIRM_RESET })
}
